<template>
  <div id="center">
    <div class="up">
<!--      <div-->
<!--          class="item"-->
<!--          v-for="item in titleItem"-->
<!--          :key="item.title"-->
<!--      >-->
<!--        <dv-border-box-12 style="height: 100px;">-->
<!--          <div class="titleDiv" style="padding: 10px">-->
<!--            <el-tag class="tileSize" >{{ item.title }}</el-tag>-->
<!--          </div>-->
<!--          <div>-->
<!--            <dv-digital-flop-->
<!--                class="dv-dig-flop mt-2"-->
<!--                :config="item.number"-->
<!--            />-->
<!--          </div>-->
<!--        </dv-border-box-12>-->
<!--      </div>-->
      <div class="chartBox"  id="weekBox" style="width: 100%">
        <div class="titleDiv" style="padding: 10px">
          <el-tag class="tileSize" v-html="chartTitle">周活跃人数</el-tag>
        </div>
        <div ref="chartWeekContainer" style="width: 100%;height: 180px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companyDevice",
  mixins: [autoResize],
  props: [],
  data() {
    return {
      titleItem: [
        {
          title: '企业用户',
          number: {
            number: [4981],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '今日新增',
          number: {
            number: [32],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '7日活跃',
          number: {
            number: [65],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '个人用户',
          number: {
            number: [213],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '月度新增',
          number: {
            number: [543],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '月度活跃',
          number: {
            number: [321],
            toFixed: 0,
            textAlign: 'center',
            content: '{nt}人',
            style: {
              fontSize: 26
            }
          }
        },
      ],
      currentIndex: 0, // 当前显示图表的索引
      loopInterval: 5000 ,// 图表循环间隔，单位为毫秒，默认为 3000 毫秒（3 秒）
      myMonthChart: null,
      myWeekChart: null,
      myUserTypeChart: null,
      chartTitle: ''
    }
  },
  watch: {

  },
  components: {
  },
  mounted() {
    this.initWeekChart();
    // 板块展示5秒切换一次
    this.changeDiv()
  },
  beforeDestroy(){
    // 每次切换排行板块时清除上一次的定时器,如果不清除的话切换页面定时器就会失效。切换时间就会有问题
    window.clearInterval(this.timers)
    this.timers=null
  },
  methods: {
    initWeekChart() {
      this.chartTitle = '周活跃人数'
      const chartWeekContainer = this.$refs.chartWeekContainer;
      chartWeekContainer && echarts.init(chartWeekContainer).dispose()
      // chartWeekContainer && echarts.init(chartWeekContainer).dispose()
      this.myWeekChart = echarts.init(chartWeekContainer, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });
      const option =  {
        backgroundColor: '',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          top: '5%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                fontSize : 16      //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                fontSize : 16      //更改坐标轴文字大小
              }
            }
          }
        ],
        series: [
          {
            name: '活跃人数',
            type: 'bar',
            barWidth: '60%',
            data: [10, 52, 200, 334, 390, 0, 0]
          }
        ]
      };
      this.myWeekChart.setOption(option);
    },
    initMonthChart() {
      this.chartTitle = '月活跃人数'
      const chartWeekContainer = this.$refs.chartWeekContainer;
      chartWeekContainer && echarts.init(chartWeekContainer).dispose()
      this.myMonthChart = echarts.init(chartWeekContainer, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });
      const option =  {
        backgroundColor: '',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          top: '5%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                fontSize : 16      //更改坐标轴文字大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                fontSize : 16      //更改坐标轴文字大小
              }
            }
          },

        ],
        series: [
          {
            name: '活跃人数',
            type: 'bar',
            barWidth: '60%',
            data: [210, 252, 200, 334, 390, 312, 435, 144, 0, 0, 0, 1]
          }
        ],
      };
      this.myMonthChart.setOption(option);
    },
    initUserTypeChart() {
      this.chartTitle = '用户类型'
      const chartWeekContainer = this.$refs.chartWeekContainer;
      chartWeekContainer && echarts.init(chartWeekContainer).dispose()
      this.myUserTypeChart = echarts.init(chartWeekContainer, 'dark', {
        renderer: 'canvas',
        useDirtyRect: false,
      });
      const option = {
        backgroundColor: '',
        tooltip: {
          trigger: 'item'
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '0',
          containLabel: true
        },
        legend: {
          show: false
        },
        series: [
          {
            name: '用户类型',
            type: 'pie',
            radius: ['40%', '70%'],
            labelLine: {
              normal: {
                formatter: '{b}  {d}%  ',
              }
            },
            data: [
              { value: 6048, name: '企业用户' },
              { value: 735, name: '个人用户' }
            ],
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 18 }
              },
              emphasis: {
                "show": true
              }
            },
            left: '-40%',
            right: '0',
            top: 0,
            bottom: 0
          },
          {
            name: '用户类型',
            type: 'pie',
            radius: ['40%', '70%'],
            labelLine: {
              normal: {
                formatter: '{b}  {d}%  ',
              }
            },
            data: [
              { value: 2048, name: '免费用户' },
              { value: 235, name: '付费用户' }
            ],
            label: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 18 }
              },
              emphasis: {
                "show": true
              }
            },
            left: '40%',
            right: 0,
            top: 0,
            bottom: 0
          }
        ]
      };
      this.myUserTypeChart.setOption(option);
    },
    changeDiv(){
      if(this.currentIndex == 0){
        this.currentIndex = 1;
        this.initMonthChart()
      } else if (this.currentIndex == 1) {
       this.currentIndex = 2
        this.initWeekChart()
      } else {
        this.currentIndex = 0
        this.initUserTypeChart()
      }
      setTimeout(this.changeDiv, this.loopInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    height: 40%;
    .titleDiv {
      width: 100%;
      align-items: center;
      display: flex;
      .tileSize {
        color: rgb(0, 186, 255);
        font-size: 20px;
        text-align: center;
        width:90%;
        margin: 0 auto
      }
    }
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      .dv-dig-flop {
        width: 100%;
        height: 30px;
      }

    }
  }
  .down {
    margin-top: 10px;
    width: 100%;
    height: 450px;
  }
}
</style>
